import { AccountDeletionDialog } from "../SettingsSections.web";
export function SettingsAccountDeletion({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) {
  return <AccountDeletionDialog open={visible} onClose={onClose} />;
}
